import React from 'react';
import './Profile.css';
import profile from '../../assets/profile.png';
import ShowLoading from '../helperComponent/ShowLoading';

const ProfileDetails = ({ userData }) => {
  const appName = userData.app_name;
  const userName = userData.username;
  const ownerName = userData.owner_name;
  const ownerContact = userData.owner_contact;
  const ownerEmail = userData.owner_email;
  const daysLeft = userData.membership_days_left;

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={profile} alt='profile' width='50' />
          <div className='main_greeting'>
            <h1>Profile Details</h1>
            <p>Here is your profile details</p>
          </div>
        </div>

        <div className='user-details'>
          <div className='detail'>
            <h2>App Name</h2>
            <p>{appName ? appName : <ShowLoading />}</p>
          </div>
          <div className='detail'>
            <h2>User Name</h2>
            <p>{userName}</p>
          </div>
          <div className='detail'>
            <h2>Owner Name</h2>
            <p>{ownerName}</p>
          </div>
          <div className='detail'>
            <h2>Owner Contact</h2>
            <p>{ownerContact}</p>
          </div>
          <div className='detail'>
            <h2>Owner Email</h2>
            <p>{ownerEmail}</p>
          </div>
          <div className='detail alert'>
            <h2>Membership Days Left</h2>
            <p
              className={
                daysLeft < 50 ? 'red' : daysLeft > 100 ? 'green' : 'yellow'
              }
            >
              {daysLeft}
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProfileDetails;
